const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const toNonEmptyString = (value) => {
  if (value === undefined || value === null) return null;
  const normalized = String(value).trim();
  return normalized ? normalized : null;
};

const pickScenarioDescription = (scenario = {}) =>
  toNonEmptyString(scenario.description)
  || toNonEmptyString(scenario.descr)
  || null;

const createMinimalScenarioFromConfig = (config = {}) => {
  const scenarioId = toNonEmptyString(config.scenarioId);
  const scenarioName = toNonEmptyString(config.scenarioName);
  const scenarioDescription = toNonEmptyString(config.scenarioDescription);
  const locId = toNonEmptyString(config.loc_id);

  if (!scenarioId && !scenarioName && !scenarioDescription && !locId) return null;

  const minimalScenario = {};
  if (scenarioId) minimalScenario.id = scenarioId;
  if (scenarioName) minimalScenario.name = scenarioName;
  if (scenarioDescription) {
    minimalScenario.description = scenarioDescription;
    minimalScenario.descr = scenarioDescription;
  }
  if (locId) {
    minimalScenario.loc_id = locId;
    minimalScenario.loc = locId;
  }
  if (config.startTime !== undefined) minimalScenario.startTime = config.startTime;
  if (Array.isArray(config.tags)) minimalScenario.tags = config.tags;
  if (config.goal !== undefined) minimalScenario.goal = config.goal;

  return minimalScenario;
};

const cloneScenario = (scenario) => {
  if (!isPlainObject(scenario)) return null;
  return { ...scenario };
};

export const getScenarioFromHangoutConfig = (config = {}) => {
  if (!isPlainObject(config)) return null;

  const selectedScenario = cloneScenario(config.selectedScenario);
  if (selectedScenario) return selectedScenario;

  return createMinimalScenarioFromConfig(config);
};

export const getScenarioIdFromHangoutConfig = (config = {}) => {
  if (!isPlainObject(config)) return null;
  const nestedScenario = getScenarioFromHangoutConfig(config);
  return toNonEmptyString(config.scenarioId)
    || toNonEmptyString(nestedScenario?.id)
    || toNonEmptyString(nestedScenario?.scenarioId)
    || null;
};

export const getScenarioNameFromHangoutConfig = (config = {}, fallback = null) => {
  if (!isPlainObject(config)) return fallback;
  const nestedScenario = getScenarioFromHangoutConfig(config);
  return toNonEmptyString(nestedScenario?.name)
    || toNonEmptyString(nestedScenario?.scenarioName)
    || toNonEmptyString(config.scenarioName)
    || fallback;
};

export const getScenarioDescriptionFromHangoutConfig = (config = {}, fallback = null) => {
  if (!isPlainObject(config)) return fallback;
  const nestedScenario = getScenarioFromHangoutConfig(config);
  return toNonEmptyString(config.scenarioDescription)
    || toNonEmptyString(config.customScenarioDescription)
    || pickScenarioDescription(nestedScenario)
    || fallback;
};

export const normalizeHangoutScenarioConfig = (config = {}) => {
  if (!isPlainObject(config)) return { config, wasNormalized: false };

  const normalizedConfig = { ...config };
  let wasNormalized = false;

  const nestedScenario = getScenarioFromHangoutConfig(normalizedConfig);
  if (nestedScenario) {
    const currentSelectedScenario = isPlainObject(normalizedConfig.selectedScenario)
      ? normalizedConfig.selectedScenario
      : null;
    const currentSelectedScenarioRaw = currentSelectedScenario ? JSON.stringify(currentSelectedScenario) : null;
    const nextSelectedScenarioRaw = JSON.stringify(nestedScenario);
    if (currentSelectedScenarioRaw !== nextSelectedScenarioRaw) {
      normalizedConfig.selectedScenario = nestedScenario;
      wasNormalized = true;
    }
  }

  const scenarioId = getScenarioIdFromHangoutConfig(normalizedConfig);
  if (scenarioId && toNonEmptyString(normalizedConfig.scenarioId) !== scenarioId) {
    normalizedConfig.scenarioId = scenarioId;
    wasNormalized = true;
  }

  if (Object.prototype.hasOwnProperty.call(normalizedConfig, 'scenario')) {
    delete normalizedConfig.scenario;
    wasNormalized = true;
  }
  if (Object.prototype.hasOwnProperty.call(normalizedConfig, 'scenarioName')) {
    delete normalizedConfig.scenarioName;
    wasNormalized = true;
  }

  return { config: normalizedConfig, wasNormalized };
};
